var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7365 12.9865L20.7364 12.9865L13.9864 19.7365C13.8574 19.8655 13.6824 19.938 13.5 19.938C13.3176 19.938 13.1426 19.8655 13.0136 19.7365C12.8846 19.6075 12.8121 19.4325 12.8121 19.2501C12.8121 19.0676 12.8846 18.8926 13.0136 18.7636L18.4839 13.2942L18.5906 13.1876H18.4397H3.75C3.56766 13.1876 3.3928 13.1151 3.26386 12.9862C3.13493 12.8573 3.0625 12.6824 3.0625 12.5001C3.0625 12.3177 3.13493 12.1428 3.26386 12.0139C3.3928 11.885 3.56766 11.8126 3.75 11.8126H18.4397H18.5906L18.4839 11.7059L13.0136 6.23648C12.8846 6.10747 12.8121 5.9325 12.8121 5.75005C12.8121 5.5676 12.8846 5.39263 13.0136 5.26362C13.1426 5.13461 13.3176 5.06213 13.5 5.06213C13.6824 5.06213 13.8574 5.13461 13.9864 5.26362L20.7364 12.0136L20.7365 12.0136C20.8004 12.0775 20.8511 12.1533 20.8857 12.2368C20.9203 12.3202 20.9381 12.4097 20.9381 12.5001C20.9381 12.5904 20.9203 12.6799 20.8857 12.7633C20.8511 12.8468 20.8004 12.9226 20.7365 12.9865Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.83d4fe0b11923ac593a9bd9ab7e74c6b.svg";
export { ForwardRef as ReactComponent };